module.exports = __webpack_public_path__ + "img/64_11.1929beac.png";